var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.CrossTenantDelegationHistory"),
        width: "600px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { height: "350px", padding: "0" }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%" },
            attrs: {
              "show-side-bar": false,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c(
        "span",
        {
          staticStyle: { padding: "10px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "div",
            { staticStyle: { float: "right" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.exportExcel(_vm.columnDefs, _vm.rowData)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DataExport")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }